import React, { useState } from 'react';
import {
  Table, Tag, Badge, Button, DatePicker, Select, Input, Drawer,
  Card
} from 'antd';

const { RangePicker } = DatePicker;
const { Option } = Select;
const { Search } = Input;

const mockData = [{
  id:1,
  datetime:'2025-11-22 14:32',
  userName:'Raja Ram',
  assetCode:'TCO-3904',
  audioTranslated: true,
  messageTypes:['Complaint','Job Card Manpower Work Done'],
  actionSuggested:'Update JC/AMD/190 (TCO-3904)',
  jsonPayloadStatus:'Generated',
  postedToAssetPro: true,
  editViewOpened: false,
  voucherNo:'JC/AMD/190',
  reviewedBy:'',
  reviewedByDateTime:'',
  audioUrl:'',
  transcription:'Sample transcription text from audio file...',
  jsonPayload:{hello:'world'}
}, {
  id:2,
  datetime:'2025-11-22 15:45',
  userName:'Raja Ram',
  assetCode:'TCO-3905',
  audioTranslated: true,
  messageTypes:['Maintenance Request'],
  actionSuggested:'Create Maintenance Ticket (TCO-3905)',
  jsonPayloadStatus:'Generated',
  postedToAssetPro: true,
  editViewOpened: true,
  voucherNo:'MT/AMD/191',
  reviewedBy:'John Doe',
  reviewedByDateTime:'2025-11-22 16:00',
  audioUrl:'',
  transcription:'Maintenance required for asset TCO-3905...',
  jsonPayload:{type:'maintenance', asset:'TCO-3905'}
}];

const statusToBadge = s => <Badge status="processing" text={s} />;

const VoiceLogsPage = () => {
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [selected, setSelected] = useState(null);

  const columns = [
    {
      title:'Date & Time',
      dataIndex:'datetime',
      width: 150,
      fixed: 'left'
    },
    {
      title:'User Name',
      dataIndex:'userName',
      width: 120
    },
    {
      title:'Asset',
      dataIndex:'assetCode',
      width: 120
    },
    {
      title:'Audio Translated',
      dataIndex:'audioTranslated',
      width: 130,
      render: (translated) => (
        <Badge 
          status={translated ? "success" : "default"} 
          text={translated ? "Yes" : "No"} 
        />
      )
    },
    {
      title:'Type of Message',
      dataIndex:'messageTypes',
      width: 200,
      render: (types) => types && types.length > 0 ? (
        <div>
          {types.map((x, idx) => (
            <Tag key={idx} style={{marginBottom: 4}}>{x}</Tag>
          ))}
        </div>
      ) : '-'
    },
    {
      title:'Action Suggested',
      dataIndex:'actionSuggested',
      width: 250,
      ellipsis: true
    },
    {
      title:'JSON Payload',
      dataIndex:'jsonPayloadStatus',
      width: 120,
      render: (status) => (
        <Badge 
          status={status === 'Generated' ? "success" : "default"} 
          text={status || 'Pending'} 
        />
      )
    },
    {
      title:'Posted to AssetPro',
      dataIndex:'postedToAssetPro',
      width: 140,
      render: (posted) => (
        <Badge 
          status={posted ? "success" : "default"} 
          text={posted ? "Posted" : "Pending"} 
        />
      )
    },
    {
      title:'Edit View',
      dataIndex:'editViewOpened',
      width: 100,
      render: (opened) => (
        <Badge 
          status={opened ? "processing" : "default"} 
          text={opened ? "Opened" : "Not Opened"} 
        />
      )
    },
    {
      title:'Voucher Number',
      dataIndex:'voucherNo',
      width: 150
    },
    {
      title:'Reviewed By',
      dataIndex:'reviewedBy',
      width: 120,
      render: (reviewer) => reviewer || <span style={{color: '#999'}}>Pending</span>
    },
    {
      title:'Reviewed Date Time',
      dataIndex:'reviewedByDateTime',
      width: 180,
      render: (dateTime) => dateTime || <span style={{color: '#999'}}>Not Reviewed</span>
    },
    {
      title:'Actions',
      width: 100,
      fixed: 'right',
      render:(_,r)=>
        <Button 
          type="primary"
          size="small"
          onClick={()=>{setSelected(r);setDrawerVisible(true);}}
        >
          View Details
        </Button>
    }
  ];

  return (
    <div style={{padding:24}}>
      <Card style={{marginBottom:16}}>
        <RangePicker />
        <Select style={{width:150, marginLeft:8}} allowClear placeholder="User">
          <Option value="Raja Ram">Raja Ram</Option>
        </Select>
        <Search style={{width:200, marginLeft:8}} placeholder="Search"/>
      </Card>

      <Table 
        rowKey="id" 
        dataSource={mockData} 
        columns={columns}
        scroll={{ x: 1800 }}
        pagination={{ pageSize: 10 }}
        size="small"
      />

      <Drawer
        width={700}
        visible={drawerVisible}
        onClose={()=>setDrawerVisible(false)}
        title="Voice Log Details"
      >
        {selected && (
          <div>
            <Card title="Date & Time" style={{marginBottom: 16}}>
              <p>{selected.datetime}</p>
            </Card>
            <Card title="User Name" style={{marginBottom: 16}}>
              <p>{selected.userName}</p>
            </Card>
            <Card title="Asset Code" style={{marginBottom: 16}}>
              <p>{selected.assetCode}</p>
            </Card>
            <Card title="Audio Translation (Transcription)" style={{marginBottom: 16}}>
              <p>{selected.transcription}</p>
              <Badge 
                status={selected.audioTranslated ? "success" : "default"} 
                text={selected.audioTranslated ? "Translated" : "Pending Translation"} 
              />
            </Card>
            <Card title="Type of Message" style={{marginBottom: 16}}>
              {selected.messageTypes && selected.messageTypes.map((type, idx) => (
                <Tag key={idx} style={{marginBottom: 4}}>{type}</Tag>
              ))}
            </Card>
            <Card title="Action Suggested" style={{marginBottom: 16}}>
              <p>{selected.actionSuggested}</p>
            </Card>
            <Card title="JSON Payload" style={{marginBottom: 16}}>
              <pre style={{background: '#f5f5f5', padding: 12, borderRadius: 4, overflow: 'auto'}}>
                {JSON.stringify(selected.jsonPayload, null, 2)}
              </pre>
              <Badge 
                status={selected.jsonPayloadStatus === 'Generated' ? "success" : "default"} 
                text={selected.jsonPayloadStatus || 'Pending'} 
                style={{marginTop: 8}}
              />
            </Card>
            <Card title="AssetPro Status" style={{marginBottom: 16}}>
              <p><strong>Posted:</strong> {selected.postedToAssetPro ? 'Yes' : 'No'}</p>
              <p><strong>Edit View Opened:</strong> {selected.editViewOpened ? 'Yes' : 'No'}</p>
              <p><strong>Voucher Number:</strong> {selected.voucherNo || 'Not Assigned'}</p>
            </Card>
            <Card title="Review Status" style={{marginBottom: 16}}>
              <p><strong>Reviewed By:</strong> {selected.reviewedBy || 'Pending Review'}</p>
              <p><strong>Reviewed Date Time:</strong> {selected.reviewedByDateTime || 'Not Reviewed'}</p>
            </Card>
          </div>
        )}
      </Drawer>
    </div>
  );
};

export default VoiceLogsPage;
